import { EpisodeCategory } from '@common/enums';

const carePathsWithSplitView = [EpisodeCategory.bariatrics];

export function isSplitViewEnabledForCarePath(episodeCategory: EpisodeCategory) {
    return carePathsWithSplitView.includes(episodeCategory);
}
